export const translationTestPortals_en = {
  pageTitle: "Test portals",
  pageSubtitle:
    "Create shareable test portals so customers and internal testers can try the chatbot and give structured feedback — without dashboard logins.",
  createPortal: "Create test portal",
  createFirstPortal: "Create your first test portal",
  editPortal: "Edit test portal",
  organizationPickerEyebrow: "Organization",
  organizationPickerTitle: "Choose an organization",
  organizationPickerSubtitle:
    "Choose the organization whose test portals you want to manage. Portals are visible and editable by users in the same organization.",
  organizationSearchPlaceholder: "Search organizations, domains, or chatbot IDs",
  organizationLoadError: "Could not load organizations.",
  organizationRequired: "Choose an organization first.",
  selectedOrganization: "Organization: {name}",
  changeOrganization: "Change organization",
  organizationsShowing: "Showing {count} of {total} organizations",
  previous: "Previous",
  next: "Next",
  pageOf: "Page {page} of {pages}",
  loadingOrganizations: "Loading organizations...",
  noOrganizationsFound: "No organizations found.",
  adminAccess: "Admin Access",
  ownerAccess: "Owner Access",
  noDomainsConfigured: "No domains configured",
  loading: "Loading...",
  loadError: "Could not load test portals.",
  saveError: "Could not save the test portal.",
  feedbackLoadError: "Could not load tester feedback.",
  emptyTitle: "No test portals yet",
  emptySubtitle:
    "Create a test portal, pick the chatbots you want to test, and share the link with your team or customer.",
  active: "Active",
  disabled: "Disabled",
  enable: "Enable",
  disable: "Disable",
  edit: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  save: "Save",
  saving: "Saving...",
  chatbot: "chatbot",
  chatbots: "chatbots",
  copyLink: "Copy link",
  copied: "Copied",
  copyManualPrompt: "Copy this link manually:",
  viewFeedback: "View feedback",
  confirmDelete: 'Are you sure you want to delete "{name}"?',
  confirmDisable: 'Disabling "{name}" will make the share link stop working for testers. Continue?',
  confirmDeleteFeedback: "Delete this feedback entry?",
  confirmRotateToken:
    'Rotating the token will immediately invalidate the existing tester share link for "{name}". Continue?',
  rotateToken: "Rotate link",
  openPortal: "Open portal",
  shareLink: "Share link",
  includedChatbots: "Included chatbots",
  backToList: "Back to list",
  created: "Created",
  testerFeedback: "Tester feedback",
  test_feedback: "test feedback",
  feedbackReportsDescription:
    "Tester feedback is now stored as regular conversation reports with the {type} report type. Use the existing Conversations filters, comments, status changes, and export flows to work through it.",
  openFeedbackReports: "Open test feedback reports",
  filterAllStatuses: "All statuses",
  noFeedbackYet: "No feedback received yet.",
  statTotalFeedback: "Total feedback",
  statOpen: "Open",
  statHighSeverity: "High severity",
  statBugs: "Bugs",
  expectedAnswer: "Expected answer",
  testerInternal: "Internal tester",
  testerExternal: "External tester",
  fieldName: "Name",
  namePlaceholder: "e.g. Internal customer-service test",
  fieldDescription: "Description",
  descriptionPlaceholder: "Tell testers what this portal is about...",
  fieldWelcomeMessage: "Welcome message",
  welcomePlaceholder: "Welcome! Try the chatbot and share your feedback.",
  fieldChatbots: "Chatbots",
  chatbotsHint: "Testers will be able to switch between the selected chatbots.",
  noChatbotsAvailable: "No chatbots available in your scope.",
  requireTesterIdentity: "Require name/email from testers when submitting feedback",
  fieldActive: "Portal is active",
  nameRequired: "Name is required",
  chatbotRequired: "Select at least one chatbot",
  status_open: "Open",
  status_in_review: "In review",
  status_resolved: "Resolved",
  status_dismissed: "Dismissed",
  category_bug: "Bug",
  category_incorrect_answer: "Incorrect answer",
  category_missing_info: "Missing info",
  category_suggestion: "Suggestion",
  category_general: "General",
  severity_low: "Low",
  severity_medium: "Medium",
  severity_high: "High",
};
